import React, { useState, useEffect } from "react";
import logo from "../assets/digitalparag/DigirtalParag.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show or hide the button based on scroll position
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  useEffect(() => {
    // Create and append the first script for authentication
    const script1 = document.createElement("script");
    script1.src =
      "https://www.freevisitorcounters.com/auth.php?id=8751532ab98cf6b029f82907fcf0cb1ed5351d77";
    script1.type = "text/javascript";
    document.body.appendChild(script1);

    // Create and append the second script for the counter
    const script2 = document.createElement("script");
    script2.src =
      "https://www.freevisitorcounters.com/en/home/counter/1281467/t/13";
    script2.type = "text/javascript";
    document.body.appendChild(script2);

    // Cleanup scripts on component unmount
    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []); // Run only once when the component is mounted

  return (
    <footer
      class="bg-center bg-fixed"
      style={{
        backgroundImage:
          "linear-gradient(158deg, orange 0%, white 50%, green 100%)",
      }}
    >
      <div class="container p-6 mx-auto pb-10">
        {/* <div className="footer-menu text-center">
          <div className="d-inline-flex gap-5 mb-0 m-auto">
            <Link className="fw-bold" to={'/'}>Home</Link>
            <Link className="fw-bold" to={'/da_calculation'}>DA Diff</Link>
            <Link className="fw-bold" to={'/govt_books_gr'}>Govt Books</Link>
            <div className="column">
              <Link className="fw-bold mb-0" to={'/contact'}>Contact</Link> <br />
              <Link className="fw-bold text-white" to={"mailto:info@digitalparag.com"}>info@digitalparag.com</Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-2 col-12 text-right"></div>
            <div className="col-lg-3 col-12 text-right">
              <Link to="/" className="mt-0">
                <img src={logo} alt="Logo" className="w-75" />
              </Link>

            </div>
          </div>
        </div> */}
        <div class="lg:flex">
          <div class="w-full -mx-6 lg:w-2/5">
            <div class="flex flex-col items-center justify-center px-6 text-center">
              <div class="text-center mt-10 lg:text-left">
                <Link to="/" className="hidden md:block">
                  <img src={logo} alt="Logo" className="h-16" />
                </Link>
              </div>
              <p className="max-w-md mx-auto mt-2 text-black text-center px-4">
                N 7, CIDCO, chatrapati sambhajinagar 431003
              </p>
            </div>
            <div className="text-center pt-5 position-relative">
              <a href="http://www.freevisitorcounters.com">
                freevisitorcounters
              </a>
              <div id="visitor-counter"></div>
            </div>
          </div>

          <div class="mt-6 lg:mt-0 lg:flex-1">
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
              <div class="text-left mt-10 lg:text-left">
                <h3 class="text-black uppercase font-bold">Our Services</h3>{" "}
                <br />
                <Link
                  to={"/da_calculation"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  DA Calculation
                </Link>
                <Link
                  to={"/govt_books_gr"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Govt Books & GR
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Income Tax Calculation
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Inter District Transfer
                </Link>
              </div>
              <div class="text-left mt-10 lg:text-left">
                <h3 class="text-black uppercase font-bold">Our Services</h3>{" "}
                <br />
                {/* <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  PAY FIXATION (Final)
                </Link> */}
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Leave Encashment Propasal (Final)
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  GPF Propasal (Non-Refundable)
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  GPF Propasal (Final)
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Pension Propasal
                </Link>
              </div>

              {/* <div class="text-left mt-10 lg:text-left">
                <h3 class="text-black uppercase  font-bold">Our Services</h3>{" "}
                <br />
                <Link
                  to={"/"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Website Design
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Terms & Conditions
                </Link>
                <Link
                  to={"/sign_in"}
                  class="block mt-2 text-sm text-black hover:underline"
                >
                  Privacy Policey
                </Link>
              </div> */}

              <div class="text-left mt-10 lg:text-left">
                <h3 class="text-black uppercase  font-bold">Contact</h3> <br />
                {/* <Link
                  to={"tel:+918329107522"}
                  className="block mt-2 text-sm text-black hover:underline"
                >
                  +91-8329107522
                </Link> */}
                <Link
                  to={"mailto:info@digitalparag.com"}
                  className="block mt-2 text-sm text-black hover:underline"
                >
                  info@digitalparag.com
                </Link>
                <div class="flex justify-center  mt-6 -mx-2 lg:justify-start">
                  <a
                    href="#"
                    class="mx-2 text-black transition-colors duration-300 hover:text-green-400 "
                    aria-label="WhatsApp"
                  >
                    <svg
                      class="w-5 h-5 fill-current"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16.001 0C7.164 0 0 7.163 0 15.999c0 2.816.736 5.548 2.128 7.962L.193 31.806l8.08-2.104a15.921 15.921 0 0 0 7.729 1.965c8.837 0 16-7.163 16-16C32.001 7.163 24.838 0 16.001 0zm0 29.318c-2.569 0-5.073-.681-7.271-1.969l-.521-.311-4.801 1.251 1.278-4.676-.34-.541A13.161 13.161 0 0 1 2.71 15.999c0-7.358 5.992-13.35 13.352-13.35 7.358 0 13.35 5.992 13.35 13.35.001 7.359-5.992 13.352-13.351 13.352zm7.316-9.867c-.398-.199-2.365-1.164-2.734-1.296-.368-.134-.637-.199-.906.2s-1.041 1.296-1.276 1.562c-.234.268-.468.299-.866.1-.399-.2-1.687-.618-3.217-1.971-1.188-1.057-1.988-2.357-2.22-2.756-.233-.4-.024-.614.175-.813.18-.178.399-.466.599-.699.2-.233.266-.399.4-.665.134-.267.067-.5-.034-.699-.101-.2-.906-2.181-1.24-2.98-.328-.789-.662-.686-.906-.686h-.755c-.234 0-.619.1-.945.466-.333.4-1.28 1.248-1.28 3.037s1.31 3.519 1.491 3.761c.183.244 2.584 3.947 6.263 5.533.876.377 1.559.602 2.092.77.88.28 1.68.241 2.313.146.706-.104 2.165-.884 2.471-1.738.307-.854.307-1.586.214-1.738-.092-.15-.366-.234-.765-.433z" />
                    </svg>
                  </a>

                  <a
                    href="#"
                    class="mx-2 text-black transition-colors duration-300  hover:text-blue-600 dark:hover:text-blue-600"
                    aria-label="Facebook"
                  >
                    <svg
                      class="w-6 h-6 fill-current"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2.00195 12.002C2.00312 16.9214 5.58036 21.1101 10.439 21.881V14.892H7.90195V12.002H10.442V9.80204C10.3284 8.75958 10.6845 7.72064 11.4136 6.96698C12.1427 6.21332 13.1693 5.82306 14.215 5.90204C14.9655 5.91417 15.7141 5.98101 16.455 6.10205V8.56104H15.191C14.7558 8.50405 14.3183 8.64777 14.0017 8.95171C13.6851 9.25566 13.5237 9.68693 13.563 10.124V12.002H16.334L15.891 14.893H13.563V21.881C18.8174 21.0506 22.502 16.2518 21.9475 10.9611C21.3929 5.67041 16.7932 1.73997 11.4808 2.01722C6.16831 2.29447 2.0028 6.68235 2.00195 12.002Z"></path>
                    </svg>
                  </a>

                  <a
                    href="#"
                    class="mx-2 text-black transition-colors duration-300  hover:text-pink-500 dark:hover:text-pink-400"
                    aria-label="Instagram"
                  >
                    <svg
                      class="w-6 h-6 fill-current"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7.75 2h8.5C19.925 2 22 4.075 22 7.75v8.5C22 19.925 19.925 22 16.25 22h-8.5C4.075 22 2 19.925 2 16.25v-8.5C2 4.075 4.075 2 7.75 2zm6.377 1.5h-4.254c-.93 0-1.383.008-1.865.053-.482.046-.815.106-1.123.222-.397.145-.683.318-.98.614-.297.297-.469.584-.614.98-.116.308-.176.64-.222 1.123-.045.482-.052.935-.052 1.865v4.254c0 .93.008 1.383.053 1.865.046.482.106.815.222 1.123.145.397.318.683.614.98.297.297.584.469.98.614.308.116.64.176 1.123.222.482.045.935.052 1.865.052h4.254c.93 0 1.383-.008 1.865-.053.482-.046.815-.106 1.123-.222.397-.145.683-.318.98-.614.297-.297.469-.584.614-.98.116-.308.176-.64.222-1.123.045-.482.052-.935.052-1.865v-4.254c0-.93-.008-1.383-.053-1.865-.046-.482-.106-.815-.222-1.123-.145-.397-.318-.683-.614-.98-.297-.297-.584-.469-.98-.614-.308-.116-.64-.176-1.123-.222-.482-.045-.935-.052-1.865-.052zM12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zm0 7.5a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5zm4.875-7.125a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z" />
                    </svg>
                  </a>

                  <a
                    href="#"
                    class="mx-2 text-black transition-colors duration-300 hover:text-blue-500 dark:hover:text-blue-400"
                    aria-label="LinkedIn"
                  >
                    <svg
                      class="w-6 h-6 fill-current"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M19 0h-14C2.238 0 0 2.238 0 5v14c0 2.762 2.238 5 5 5h14c2.762 0 5-2.238 5-5V5c0-2.762-2.238-5-5-5zm-11.5 19h-3v-9h3v9zm-1.5-10.25c-.966 0-1.75-.784-1.75-1.75S5.034 5.25 6 5.25s1.75.784 1.75 1.75S6.966 8.75 6 8.75zm13.5 10.25h-3v-4.5c0-1.12-.92-2-2-2s-2 .88-2 2v4.5h-3v-9h3v1.5c.77-1.14 2.03-1.5 3.25-1.5 2.21 0 4 1.79 4 4v5z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <hr class="h-px my-6 bg-gray-200 border-none dark:bg-yellow-500" />

                <div>
                    <p class="text-center text-white">© Copyright <span className='font-bold'>Viransh Global Legal Pvt Ltd </span> .  All Rights Reserved</p>
                    <p className='text-center text-white'>Designed by <a href="https://maharashtrainformatics.com/" target='/' className='hover:underline'> <span className='text-red-600 hover:text-red-300'>Maharashtra Informatics Opc Pvt Ltd</span> </a> </p>
                </div> */}
      </div>

      {/* Back-to-Top Button */}
      {isVisible && (
        <div
          onClick={scrollToTop}
          className="fixed bottom-5 right-3 z-50 bg-[#FD3400] w-10 h-10 rounded-full flex justify-center items-center cursor-pointer transition-opacity duration-400 opacity-100 hover:bg-green-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="white"
            className="bi bi-arrow-up-short"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M8 12a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5A.5.5 0 0 1 8 12z"
            />
          </svg>
        </div>
      )}
    </footer>
  );
};

export default Footer;
